import { createEvent } from '@cobuildlab/react-simple-state';
import { TravelerTypeType } from '../../shared/types';

export const OnTravelerType = createEvent<TravelerTypeType>();
export const OnTravelrTypeError = createEvent();
